import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

export const NoSelectionView = ({ message, img }: { message: string; img?: ReactNode }) => {
    return (
        <Box p={2} m={"auto"} width={"fit-content"}>
            <Box width={"fit-content"} margin={"auto"}>
                {img !== undefined ? img : <FlyingCat />}
            </Box>
            <Box pt={3} maxWidth={"411px"}>
                <Typography variant={"h4"} align={"center"}>
                    {message}
                </Typography>
            </Box>
        </Box>
    );
};

const FlyingCat = () => {
    return (
        <svg role="img" width="192" height="98" viewBox="0 0 192 98" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.6722 24.6482C19.6722 13.5578 28.6628 4.56726 39.7532 4.56726H143.438C151.787 4.56726 158.555 11.3354 158.555 19.6843V23.337C158.555 29.6686 163.688 34.8014 170.019 34.8014C176.351 34.8014 181.484 39.9342 181.484 46.2658V73.8742C181.484 84.9646 172.493 93.9552 161.403 93.9552H89.1481C83.3402 93.9552 78.6319 89.2469 78.6319 83.439C78.6319 77.631 73.9236 72.9227 68.1157 72.9227H39.7532C28.6628 72.9227 19.6722 63.9322 19.6722 52.8418V24.6482Z"
                fill="#F3EFEC"
            />
            <ellipse cx="76.4111" cy="71.491" rx="9.33295" ry="9.34373" fill="#767676" />
            <path
                d="M82.2441 59.6563C83.0877 59.1041 84.2126 59.6737 84.2684 60.6811L84.5656 66.0452L77.7527 62.596L82.2441 59.6563Z"
                fill="#767676"
            />
            <path
                d="M66.7199 63.7718C66.5331 62.7804 67.4885 61.9582 68.4395 62.292L73.7906 64.17L67.7709 69.3503L66.7199 63.7718Z"
                fill="#767676"
            />
            <path
                d="M80.9692 71.3155C80.9692 66.252 85.074 62.1472 90.1375 62.1472H103.102C114.683 62.1472 124.072 71.5362 124.072 83.1182H80.9692V71.3155Z"
                fill="#767676"
            />
            <path
                d="M66.3762 79.3504C66.3762 78.2126 67.2986 77.2903 68.4363 77.2903H77.6938V81.4105H68.4363C67.2986 81.4105 66.3762 80.4882 66.3762 79.3504Z"
                fill="#767676"
            />
            <ellipse cx="112.776" cy="77.737" rx="8.05293" ry="8.06223" fill="#767676" />
            <path
                d="M107.708 72.1501C107.577 71.9702 107.324 71.9302 107.151 72.0706C106.337 72.7309 105.659 73.5448 105.155 74.4673C104.587 75.5081 104.255 76.6615 104.184 77.8453C104.112 79.0291 104.302 80.2142 104.74 81.3161C105.129 82.2928 105.704 83.1828 106.432 83.9368C106.587 84.097 106.843 84.0879 106.995 83.9252C107.146 83.7628 107.137 83.5088 106.984 83.3481C106.341 82.6755 105.833 81.8846 105.488 81.0178C105.094 80.0261 104.923 78.9596 104.988 77.8941C105.052 76.8287 105.351 75.7906 105.862 74.8539C106.309 74.0352 106.909 73.3116 107.627 72.7218C107.799 72.5807 107.839 72.3297 107.708 72.1501Z"
                fill="white"
            />
            <path
                d="M108.167 94.1404C107.587 95.1884 107.964 96.5293 109.1 96.9064C110.826 97.4791 112.672 97.6438 114.491 97.3741C117.028 96.9976 119.371 95.7959 121.159 93.9543C122.947 92.1126 124.079 89.7333 124.383 87.1833C124.686 84.6332 124.457 80.1379 123.508 77.3079L118.382 82.6713C119.428 83.5612 120.269 85.0658 120.078 86.6699C119.887 88.274 119.174 89.7707 118.05 90.9292C116.925 92.0878 115.451 92.8437 113.855 93.0805C112.981 93.2102 112.097 93.1802 111.244 92.9982C110.071 92.7478 108.747 93.0909 108.167 94.1404Z"
                fill="#767676"
            />
            <path
                d="M75.5867 84.6804C74.9315 83.6563 75.2302 82.2944 76.2538 81.6385L84.4519 76.3848L86.8246 80.0933L78.6264 85.3469C77.6028 86.0029 76.2419 85.7045 75.5867 84.6804Z"
                fill="#767676"
            />
            <path
                d="M74.688 85.2865V84.8912C74.688 83.1677 75.633 81.583 77.1494 80.7638L82.9062 77.6537"
                stroke="white"
                strokeWidth="1.30975"
                strokeLinecap="round"
            />
            <path d="M77.754 70.2717L80.547 68.9904" stroke="white" strokeWidth="1.30975" strokeLinecap="round" />
            <path d="M71.2326 70.0184L74.2629 70.525" stroke="white" strokeWidth="1.30975" strokeLinecap="round" />
            <path
                d="M75.4611 73.715C74.9962 73.051 75.3685 72.1279 76.1641 71.972C76.9597 71.8162 77.6521 72.5308 77.4714 73.3212L77.3524 73.8415C77.2745 74.1822 77.0033 74.445 76.6605 74.5121C76.3177 74.5793 75.9675 74.4382 75.7672 74.152L75.4611 73.715Z"
                fill="#FDC2B2"
            />
            <path
                d="M95.1494 62.2234C96.775 70.5819 96.8084 75.1388 95.1494 83.0205"
                stroke="white"
                strokeWidth="1.54232"
                strokeLinecap="round"
            />
            <path d="M95.1494 62.2234L108.064 37.9042" stroke="white" strokeWidth="1.54232" strokeLinecap="round" />
            <path d="M95.1445 62.5007L82.2351 37.0659" stroke="white" strokeWidth="1.54232" strokeLinecap="round" />
            <path d="M95.3584 61.3848V29.8538" stroke="white" strokeWidth="1.54232" strokeLinecap="round" />
            <ellipse cx="95.3584" cy="14.028" rx="13.0493" ry="14.028" fill="#FC6E51" />
            <path d="M95.3583 26.7511L97.0534 29.6872H93.6631L95.3583 26.7511Z" fill="#FC6E51" />
            <ellipse
                cx="113.553"
                cy="28.062"
                rx="9.13453"
                ry="10.7657"
                transform="rotate(26.4577 113.553 28.062)"
                fill="#3CAAF0"
            />
            <path d="M108.872 36.2534L108.736 38.8111L106.914 37.9042L108.872 36.2534Z" fill="#3CAAF0" />
            <ellipse
                cx="78.7947"
                cy="27.9715"
                rx="7.50337"
                ry="8.8083"
                transform="rotate(-20.829 78.7947 27.9715)"
                fill="#FE8F11"
            />
            <path d="M81.5865 35.4529L83.0229 36.9278L81.4937 37.5096L81.5865 35.4529Z" fill="#FE8F11" />
            <path
                d="M29.4859 25.1715C28.6888 25.1715 27.9309 25.3329 27.2362 25.6219C26.4075 21.068 22.4697 17.6166 17.7336 17.6166C12.3957 17.6166 8.06858 22.0004 8.06858 27.4081H4.63897V27.418C2.05994 27.5216 0 29.6666 0 32.3034C0 34.9402 2.16354 37.1986 4.83307 37.1986H29.4859C32.764 37.1986 35.4215 34.5062 35.4215 31.1856C35.4215 27.8651 32.764 25.1726 29.4859 25.1726V25.1715Z"
                fill="#BAE5FF"
            />
            <path
                d="M191.998 65.7584V64.9522C191.998 60.0706 188.092 56.1122 183.271 56.1122C179.489 56.1122 176.27 58.5501 175.059 61.9589C174.088 61.4035 172.97 61.0837 171.775 61.0837C168.075 61.0837 165.074 64.1229 165.074 67.8707C165.074 71.6185 168.006 74.5831 171.649 74.652V74.6578H183.254C188.084 74.6578 192 70.6916 192 65.7986V65.7565L191.998 65.7584Z"
                fill="#BAE5FF"
            />
        </svg>
    );
};
